import { render, staticRenderFns } from "./QuotationSiteCard.vue?vue&type=template&id=24ca9a64&scoped=true"
import script from "./QuotationSiteCard.vue?vue&type=script&lang=js"
export * from "./QuotationSiteCard.vue?vue&type=script&lang=js"
import style0 from "./QuotationSiteCard.vue?vue&type=style&index=0&id=24ca9a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca9a64",
  null
  
)

export default component.exports